import { useEffect } from 'react';
import { MachineType } from '../../interfaces/Brand.interfaces';
import { FilterType } from '../../interfaces/Filter.interfaces';
import { filterSlice } from '../../store/filterSlice';
import { useGetBrandsQuery } from '../api/brand/queries/useGetBrands.query';
import { useAppDispatch, useAppSelector } from '../store/useStore';

interface useAddFilterOptions {
  data: 'brands';
  filterType: FilterType;
  applicableMachineType: MachineType | 'ALL';
}

export const useAddFilterOptions = ({ data, filterType, applicableMachineType }: useAddFilterOptions) => {
  const dispatch = useAppDispatch();
  const filterStates = useAppSelector((state) => state.filter[filterType]);
  const filterActions = filterSlice.actions;

  const {
    data: brands,
    isLoading: isGetBrandsQueryLoading,
    isSuccess: isGetBrandsQuerySuccess,
  } = useGetBrandsQuery({
    searchParam: {
      applicableMachineType: applicableMachineType === 'ALL' ? '' : applicableMachineType,
    },
  });

  useEffect(() => {
    if (data === 'brands') {
      if (!filterStates.isFilterOptionsAdded.brands && isGetBrandsQuerySuccess && brands.length > 0) {
        dispatch(
          filterActions.addFilterOptions({
            filterType,
            filterKey: 'filter_brand',
            options: brands.map((brand) => ({
              optionName: brand.name,
              value: brand.id,
              isDefault: false,
              isSelected: false,
            })),
          }),
        );

        dispatch(filterActions.changeIsFilterOptionsAdded({ filterType, data: 'brands', value: true }));
        dispatch(filterActions.changeHaveToRefreshLocalStates({ filterType, value: true }));
      }
    }
  }, [filterStates.isFilterOptionsAdded, brands]);

  return { isGetBrandsQueryLoading };
};
